import { FormValidationError } from '@cian/frontend-request-form-widget';

import { isRequestFormFields, isSpecialFlowValidationErrorCode } from '../../utils/requestForm';
import { IRequestFormValidationError } from '../../types/requestFormValidation';
import { IRequestFormValue } from '../../types/requestFormValue';

export interface IMapToValidationFormErrorProps {
  errors: IRequestFormValidationError[];
  fallback: string;
}

/**
 * Преобразуем ошибки валидации с бэка в инстанс FormValidationError или Error
 */
export function mapToFormValidationError({
  errors,
  fallback,
}: IMapToValidationFormErrorProps): FormValidationError<IRequestFormValue> | Error {
  /** Если массив с ошибками пустой или включает в себя ошибки не для полей формы **/
  if (!errors.length || errors.some(({ key }) => !isRequestFormFields(key))) {
    return new Error(fallback);
  }

  /** Если для кода ошибки предусмотрен специальный флоу обработки - отдаем код, иначе - сообщение **/
  const fieldsValidationErrors = errors.reduce<{ [key: string]: string }>(
    (errors, { key, code, message }) => ({
      ...errors,
      [key]: isSpecialFlowValidationErrorCode(code) ? code : message,
    }),
    {},
  );

  return new FormValidationError({
    message: fallback,
    errors: fieldsValidationErrors,
  });
}
